export interface CanvasViewportCenter {
  x: number
  y: number
  sceneId: string
}

export interface LiveCanvasViewport {
  x: number
  y: number
  zoom: number
  sceneId: string
}

// High-frequency, non-reactive cache used by action-time placement reads and
// narrow imperative subscriptions such as the onboarding gesture check. The
// normal Yjs/Zustand field remains the debounced render snapshot; keeping this
// outside React prevents camera gestures from re-rendering the canvas panel
// and asset sidebar on every viewport event.
let liveCenter: CanvasViewportCenter | null = null
let liveViewport: LiveCanvasViewport | null = null
const viewportListeners = new Set<(viewport: LiveCanvasViewport | null) => void>()

export function setLiveCanvasViewportCenter(center: CanvasViewportCenter | null): void {
  liveCenter = center
}

export function getLiveCanvasViewportCenter(sceneId: string): CanvasViewportCenter | null {
  return liveCenter?.sceneId === sceneId ? liveCenter : null
}

export function setLiveCanvasViewport(viewport: LiveCanvasViewport | null): void {
  liveViewport = viewport
  viewportListeners.forEach(listener => listener(viewport))
}

export function getLiveCanvasViewport(): LiveCanvasViewport | null {
  return liveViewport
}

export function subscribeLiveCanvasViewport(listener: (viewport: LiveCanvasViewport | null) => void): () => void {
  viewportListeners.add(listener)
  return () => viewportListeners.delete(listener)
}

export function clearLiveCanvasViewportCenter(sceneId: string): void {
  if (liveCenter?.sceneId === sceneId) liveCenter = null
}

export function clearLiveCanvasViewport(sceneId: string): void {
  if (liveViewport?.sceneId !== sceneId) return
  setLiveCanvasViewport(null)
}
